// App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes'; // Import the AppRoutes component

function App() {
	return <AppRoutes />;
}

export default App;
